import { GET_USER_IDENTITY } from '~/graphql/queries/getUserIdentity'
import { decodeGlobalId } from '~/utils/id'
import { initializeApollo } from '~/lib/apolloClient'
import getIdentifyPayload from '~/utils/getIdentifyPayload'

export function setTrackingIdentity({ fetchPolicy = 'cache-first', alias = true } = {}) {
  return new Promise(async resolve => {
    if (!global.analytics) return resolve(false)

    const apolloClient = initializeApollo()

    const { data } = await apolloClient.query({
      query: GET_USER_IDENTITY,
      fetchPolicy,
    })

    if (!Boolean(data?.loggedInUser?.id)) {
      return resolve(false)
    }

    const { loggedInUser: user } = data

    const userId = decodeGlobalId(user.id)

    if (alias) {
      global.analytics.alias(userId)
    }

    const identifyPayload = getIdentifyPayload(user)

    global.analytics.identify(userId, identifyPayload)

    /*
      Hotjar is loaded by the analytics.js script from Segment,
      however the identify call is not happening, so that's why
      we have to manually identify the user for Hotjar.
    */
    if (global.hj) {
      global.hj('identify', userId, identifyPayload)
    }

    resolve()
  })
}
